import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  CreateTwikeyInviteRequestV1,
  CreateTwikeyInviteResponseV1,
  GetPadVerifiedStatusRequestV1,
  GetPadVerifiedStatusResponseV1,
} from '../models';
import { CompleteTwikeyInviteRequestV1 } from '../models/twikey';

export abstract class PadAgreementService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('padAgreementServiceUrl');
  }

  abstract getPadVerifiedStatus(
    tenantId: string,
    payload: GetPadVerifiedStatusRequestV1,
  ): Observable<GetPadVerifiedStatusResponseV1>;

  abstract createTwikeyInvite(
    tenantId: string,
    payload: CreateTwikeyInviteRequestV1,
  ): Observable<CreateTwikeyInviteResponseV1>;

  abstract completeTwikeyInvite(
    tenantId: string,
    payload: CompleteTwikeyInviteRequestV1,
  ): Observable<void>;
}
